var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Input',_vm._g(_vm._b({class:_vm.prefixCls,attrs:{"rows":_vm.rows || 10},on:{"blur":()=>{
         _vm.$emit('input',_vm.defaultValue)
       }},model:{value:(_vm.defaultValue),callback:function ($$v) {_vm.defaultValue=$$v},expression:"defaultValue"}},'Input',_vm.$attrs,false),_vm.$listeners),[_c('template',{slot:"prepend"},[_vm._t("prepend")],2),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }